import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogUnprocessedEntitiesPlugin from '@backstage/plugin-catalog-unprocessed-entities/alpha';
import devtoolsPlugin from '@backstage/plugin-devtools/alpha';
import aiLibraryPlugin from '@internal/backstage-plugin-ai-library-frontend';
import aiReadinessPlugin from '@internal/backstage-plugin-ai-readiness-frontend';
import aiToolsPlugin from '@internal/backstage-plugin-ai-tools-frontend';
import apiGovernancePlugin from '@internal/backstage-plugin-api-governance-frontend';
import apiKeysPlugin from '@internal/backstage-plugin-api-keys-frontend';
import engineeringInsightsPlugin from '@internal/backstage-plugin-engineering-insights-frontend';
import entityProvidersPlugin from '@internal/backstage-plugin-entity-providers-frontend';
import kaapFrontendPlugin, {
  kaapScaffolderFieldsModule,
} from '@internal/backstage-plugin-kaap-frontend';
import homePlugin from '@internal/backstage-plugin-home-frontend';
import manageOwnershipPlugin from '@internal/backstage-plugin-manage-ownership';
import { scaffolderFieldsModule } from '@internal/backstage-plugin-scaffolder-fields-frontend';
import scorecardsPlugin from '@internal/backstage-plugin-scorecard-frontend';
import secretsSharingPlugin from '@internal/backstage-plugin-secrets-sharing-frontend';
import teamOverviewPlugin from '@internal/backstage-plugin-team-overview-frontend';
import techRadarPlugin from '@internal/backstage-plugin-tech-radar-frontend';
import tomtomLabPlugin from '@internal/backstage-plugin-tomtom-lab-frontend';
import { catalogPagesModule } from './modules/catalog';
import { catalogGraphModule } from './modules/catalogGraphModule';
import { navModule } from './modules/nav';
import { scaffolderChromeModule } from './modules/scaffolderChrome';
import { scaffolderPluginWithHiddenTemplates } from './modules/scaffolderHiddenTemplates';
import { scaffolderTranslationsModule } from './modules/scaffolderTranslations';
import { signInModule } from './modules/signIn';
import { tomtomThemeModule } from './theme';
import './styles.css';

const catalogRoutesModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      factory(originalFactory) {
        return originalFactory({
          config: {
            path: '/catalog',
          } as any,
        });
      },
    }),
    catalogPlugin.getExtension('page:catalog/entity').override({
      factory(originalFactory) {
        return originalFactory({
          config: {
            path: '/catalog/:namespace/:kind/:name',
          } as any,
        });
      },
    }),
    catalogPlugin.getExtension('entity-content:catalog/overview').override({
      factory(originalFactory) {
        return originalFactory({
          config: {
            filter: 'not:kind:group',
          } as any,
        });
      },
    }),
  ],
});

export default createApp({
  features: [
    catalogPlugin,
    catalogRoutesModule,
    catalogUnprocessedEntitiesPlugin,
    devtoolsPlugin,
    manageOwnershipPlugin,
    scorecardsPlugin,
    engineeringInsightsPlugin,
    teamOverviewPlugin,
    kaapFrontendPlugin,
    kaapScaffolderFieldsModule,
    scaffolderFieldsModule,
    aiToolsPlugin,
    aiLibraryPlugin,
    apiGovernancePlugin,
    apiKeysPlugin,
    entityProvidersPlugin,
    aiReadinessPlugin,
    secretsSharingPlugin,
    techRadarPlugin,
    tomtomLabPlugin,
    homePlugin,
    scaffolderPluginWithHiddenTemplates,
    scaffolderTranslationsModule,
    catalogPagesModule,
    catalogGraphModule,
    navModule,
    tomtomThemeModule,
    scaffolderChromeModule,
    signInModule,
  ],
});
